import { getFormatedDates } from 'core/utils/date.helpers';
import { ChallengeDatesType } from 'interfaces';

/**
 * Builds the structure required by the shared `Banner` component out of the
 * quiz payload. A quiz only carries `startDateTime`/`endDateTime`, mapped on
 * the `challenge` slot, which leads `getChallengePhase` straight to the
 * "during quiz" rendering — exactly what the spec calls for.
 */
export const getQuizDates = (
  data: { startDateTime?: string; endDateTime?: string | null } | null,
  language: string,
): ChallengeDatesType =>
  getFormatedDates(
    {
      challenge: {
        start: data?.startDateTime,
        ...(data?.endDateTime != null ? { end: data.endDateTime } : {}),
      },
    },
    { day: 'numeric', month: 'short', year: 'numeric' },
    language,
  ) as ChallengeDatesType;